import {defineSlotRecipe} from '@chakra-ui/react3'

const chakraFieldSlotRecipe = defineSlotRecipe({
    className: 'chakra-field',
    slots: [
        'root',
        'errorText',
        'helperText',
        'input',
        'label',
        'select',
        'textarea',
        'requiredIndicator',
        'requiredIndicator'
    ],
    base: {
        requiredIndicator: {
            color: 'fg.error',
            lineHeight: '1'
        },
        root: {
            display: 'flex',
            width: '100%',
            position: 'relative',
            gap: '1.5'
        },
        label: {
            display: 'flex',
            alignItems: 'center',
            textAlign: 'start',
            textStyle: 'sm',
            fontWeight: 'medium',
            gap: '1',
            userSelect: 'none',
            _disabled: {
                opacity: '0.5'
            }
        },
        errorText: {
            display: 'inline-flex',
            alignItems: 'center',
            fontWeight: 'medium',
            gap: '1',
            color: 'fg.error',
            textStyle: 'xs'
        },
        helperText: {
            color: 'fg.muted',
            textStyle: 'xs'
        }
    },
    variants: {
        orientation: {
            vertical: {
                root: {
                    flexDirection: 'column',
                    alignItems: 'flex-start'
                }
            },
            horizontal: {
                root: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                },
                label: {
                    flex: '0 0 var(--field-label-width, 80px)'
                }
            }
        }
    },
    defaultVariants: {
        orientation: 'vertical'
    }
})

export const fieldSlotRecipe = defineSlotRecipe({
    ...chakraFieldSlotRecipe,
    className: 'leap-field',
    // Chakra base recipe stays untouched above. Leap-specific styling lives only here.
    base: {
        ...chakraFieldSlotRecipe.base,
        requiredIndicator: {
            ...chakraFieldSlotRecipe.base.requiredIndicator,
            color: 'text.primary'
        },
        root: {
            ...chakraFieldSlotRecipe.base.root,
            gap: 'spacing-4'
        },
        label: {
            ...chakraFieldSlotRecipe.base.label,
            color: 'text.primary',
            textStyle: 'body.xsmall',
            fontWeight: null
        },
        errorText: {
            ...chakraFieldSlotRecipe.base.errorText,
            color: 'text.system.error',
            textStyle: 'body.xsmall',
            _icon: {
                boxSize: '4',
                color: 'icons.system.error'
            }
        },
        helperText: {
            ...chakraFieldSlotRecipe.base.helperText,
            display: 'inline-flex',
            color: 'text.primary',
            textStyle: 'body.xsmall',
            gap: '1',
            _icon: {boxSize: '4'}
        }
    },
    variants: {
        ...chakraFieldSlotRecipe.variants,
        variant: {
            checkbox: {
                helperText: {
                    // based on the XPDP configurator engraving overlay design
                    textStyle: 'body.xsmallItalic',
                    color: 'text.tertiary'
                },
                errorText: {
                    paddingInlineStart: 'spacing-28',
                    textStyle: 'body.small'
                }
            }
        }
    },
    defaultVariants: {
        orientation: 'vertical'
    }
})
